/* eslint-disable max-len */
import React from 'react';

// const SubRouter = React.lazy(() => import('../pages/subroutes'));
const HomePage = React.lazy(() => import('../pages/home'));
const LoginPage = React.lazy(() => import('../pages/account/login'));
const RegisterPage = React.lazy(() => import('../pages/account/register'));
const ForgotPasswordPage = React.lazy(() => import('../pages/account/forgot-password'));
const ResetPasswordPage = React.lazy(() => import('../pages/account/reset-password'));
const ConfirmLinkPage = React.lazy(() => import('../pages/account/confirm-link'));
const DashboardPage = React.lazy(() => import('../pages/dashboard/dashBoard'));
const MessagesPage = React.lazy(() => import('../pages/dashboard/messages'));
const MyListingPage = React.lazy(() => import('../pages/dashboard/my-listing'));
// const MyRentalPage = React.lazy(() => import('../pages/dashboard/my-rental'));
const OffersPage = React.lazy(() => import('../pages/dashboard/offers'));
const SavedHomes = React.lazy(() => import('../pages/dashboard/saved-homes'));
const PropertyInformation = React.lazy(() => import('../pages/become-a-host/property-information'));
const MediaAndDescription = React.lazy(() => import('../pages/become-a-host/media-and-description'));
const PropertyFeatures = React.lazy(() => import('../pages/become-a-host/property-features'));
const PricingAndContract = React.lazy(() => import('../pages/become-a-host/pricing-and-contract'));
const BecomeHostThankYou = React.lazy(() => import('../pages/become-a-host/thank-you'));
const SearchProperty = React.lazy(() => import('../pages/search/search-property'));
const UnderConstructionPage = React.lazy(() => import('../pages/courtesy-pages/workInProgress'));
const PrivacyPolicyPage = React.lazy(() => import('../pages/courtesy-pages/privacyPolicy'));
const CookiePolicyPage = React.lazy(() => import('../pages/courtesy-pages/cookiePolicy'));
const TermsAndConditionsPage = React.lazy(() => import('../pages/courtesy-pages/termsAndConditions'));
const HomeAdmingPage = React.lazy(() => import('../pages/admin/home'));
const CompanyInformationPage = React.lazy(() => import('../pages/about/companyInformation'));
const ViewProfilePage = React.lazy(() => import('../pages/view/viewProfile'));
// const StripeOwnerRegisterThankYouPage = React.lazy(() => import('../pages/payments/stripe-owner-register-thank-you'));

interface IRoute {
  key: string;
  component: React.LazyExoticComponent<() => JSX.Element>;
  isExact: boolean;
  isEnabled?: boolean;
  showInMenu?: boolean;
  routeStatus: 'public' | 'private' | 'restricted' | 'admin';
  path?: string;
  location?: string;
  // routes?: IRoute[],
}

const routes: IRoute[] = [
  {
    key: 'home',
    component: HomePage,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'account.login',
    component: LoginPage,
    isExact: true,
    routeStatus: 'restricted',
  },
  {
    key: 'account.register',
    component: RegisterPage,
    isExact: true,
    routeStatus: 'restricted',
  },
  {
    key: 'account.forgotPassword',
    component: ForgotPasswordPage,
    isExact: true,
    routeStatus: 'restricted',
  },
  {
    key: 'account.resetPassword',
    component: ResetPasswordPage,
    isExact: true,
    routeStatus: 'restricted',
  },
  {
    key: 'account.confirmEmail',
    component: ConfirmLinkPage,
    isExact: true,
    routeStatus: 'restricted',
  },
  {
    key: 'dashboard.profile',
    component: DashboardPage,
    isExact: true,
    routeStatus: 'private',
  },
  {
    key: 'dashboard.messages',
    component: MessagesPage,
    isExact: true,
    routeStatus: 'private',
  },
  {
    key: 'dashboard.myListing',
    component: MyListingPage,
    isExact: true,
    routeStatus: 'private',
  },
  // {
  //   key: 'dashboard.myRental',
  //   component: MyRentalPage,
  //   isExact: true,
  //   routeStatus: 'private',
  // },
  {
    key: 'dashboard.offers',
    component: OffersPage,
    isExact: true,
    routeStatus: 'private',
  },
  {
    key: 'dashboard.savedHomes',
    component: SavedHomes,
    isExact: true,
    routeStatus: 'private',
  },
  {
    key: 'becomeAHost.propertyInformation',
    component: PropertyInformation,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'becomeAHost.mediaAndDescription',
    component: MediaAndDescription,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'becomeAHost.propertyFeautures',
    component: PropertyFeatures,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'becomeAHost.pricingAndContract',
    component: PricingAndContract,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'becomeAHost.thankYou',
    component: BecomeHostThankYou,
    isExact: true,
    routeStatus: 'private',
  },
  {
    key: 'catalog',
    component: BecomeHostThankYou,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'search.property',
    component: SearchProperty,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'underConstruction',
    component: UnderConstructionPage,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'privacyPolicy',
    component: PrivacyPolicyPage,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'cookiePolicy',
    component: CookiePolicyPage,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'termsAndConditions',
    component: TermsAndConditionsPage,
    isExact: false,
    routeStatus: 'public',
  },
  {
    key: 'adminArea',
    component: HomeAdmingPage,
    isExact: true,
    routeStatus: 'admin',
  },
  {
    key: 'companyInformation',
    component: CompanyInformationPage,
    isExact: true,
    routeStatus: 'public',
  },
  {
    key: 'view.viewProfile',
    component: ViewProfilePage,
    isExact: true,
    routeStatus: 'public',
  },
  // {
  //   key: 'payment.stripeOwnerRegisterThankYou',
  //   component: StripeOwnerRegisterThankYouPage,
  //   isExact: true,
  //   routeStatus: 'private',
  // },
];

export default routes;
